export type VisualMathActiveQuestion = {
  id:string; numero:number; area:string; areaCurta:string; habilidade:string; referencia:string;
  enunciado:string; alternativas:{A:string;B:string;C:string;D:string}; correta:string; justificativa:string;
  origem:string; numeroOriginal:number; gabaritoOriginal:"A"|"B"|"C"|"D"|"E";
  visual:{sourceUrl:string;sourcePage:number;alt:string};
  visualAlternativas:{A:string;B:string;C:string;D:string};
  visualAlternativaRemovida:"A"|"B"|"C"|"D"|"E"; status:"ativo";
};
export default [
  {
    "id": "mat-enem-visual-0015",
    "numero": 1515,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "Um dos diversos instrumentos que o homem concebeu para medir o tempo foi a ampulheta, também conhecida como relógio de areia. A questão depende do esquema visual apresentado no PDF-fonte.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "C",
    "justificativa": "Questão visual original. Gabarito fonte: C. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2009.1",
    "numeroOriginal": 15,
    "gabaritoOriginal": "C",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 7,
      "alt": "Material visual original da questão 15"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0027",
    "numero": 1527,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "Questão com figura geométrica do terreno cultivado e faixa de reserva; a leitura do desenho é necessária.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "D",
    "justificativa": "Questão visual original. Gabarito fonte: D. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2009.1",
    "numeroOriginal": 27,
    "gabaritoOriginal": "D",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 11,
      "alt": "Material visual original da questão 27"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0033",
    "numero": 1533,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "Questão baseada em uma figura de tesselação de Escher; as alternativas são visuais.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "D",
    "justificativa": "Questão visual original. Gabarito fonte: D. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2009.1",
    "numeroOriginal": 33,
    "gabaritoOriginal": "D",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 13,
      "alt": "Material visual original da questão 33"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0044",
    "numero": 1544,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.1",
    "enunciado": "Questão sobre a região de interseção de dois círculos de mesmo raio; o desenho geométrico faz parte do item.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "A",
    "justificativa": "Questão visual original. Gabarito fonte: A. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2009.1",
    "numeroOriginal": 44,
    "gabaritoOriginal": "A",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 15,
      "alt": "Material visual original da questão 44"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0084",
    "numero": 1584,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.2",
    "enunciado": "Questão sobre o ponto P em uma circunferência e sua projeção Q no eixo x; o esquema é necessário.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "B",
    "justificativa": "Questão visual original. Gabarito fonte: B. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2009.2",
    "numeroOriginal": 84,
    "gabaritoOriginal": "B",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 27,
      "alt": "Material visual original da questão 84"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0092",
    "numero": 1592,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "Questão de sequência apresentada visualmente em tabela/quadro.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "C",
    "justificativa": "Questão visual original. Gabarito fonte: C. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2009.3",
    "numeroOriginal": 92,
    "gabaritoOriginal": "C",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 29,
      "alt": "Material visual original da questão 92"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0102",
    "numero": 1602,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "Questão sobre simetria em figuras; as alternativas são apresentadas graficamente.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "B",
    "justificativa": "Questão visual original. Gabarito fonte: B. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2009.3",
    "numeroOriginal": 102,
    "gabaritoOriginal": "B",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 32,
      "alt": "Material visual original da questão 102"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0109",
    "numero": 1609,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "Questão com representação gráfica/formatação matemática que não deve ser reconstruída por texto sem conferência visual.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original E"
    },
    "correta": "D",
    "justificativa": "Questão visual original. Gabarito fonte: E. No simulador de 4 opções, as alternativas originais A, B, C, E são remapeadas para A, B, C e D.",
    "origem": "2009.3",
    "numeroOriginal": 109,
    "gabaritoOriginal": "E",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 34,
      "alt": "Material visual original da questão 109"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "E"
    },
    "visualAlternativaRemovida": "D",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0115",
    "numero": 1615,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "Questão com lei de Fenchel e representação visual associada.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "B",
    "justificativa": "Questão visual original. Gabarito fonte: B. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2009.3",
    "numeroOriginal": 115,
    "gabaritoOriginal": "B",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 35,
      "alt": "Material visual original da questão 115"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0134",
    "numero": 1634,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2009.3",
    "enunciado": "Questão de cilindros tangentes com desenho tridimensional.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original E"
    },
    "correta": "D",
    "justificativa": "Questão visual original. Gabarito fonte: E. No simulador de 4 opções, as alternativas originais A, B, C, E são remapeadas para A, B, C e D.",
    "origem": "2009.3",
    "numeroOriginal": 134,
    "gabaritoOriginal": "E",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 41,
      "alt": "Material visual original da questão 134"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "E"
    },
    "visualAlternativaRemovida": "D",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0136",
    "numero": 1636,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "Questão com representação gráfica de uma divisão percentual em partes.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "C",
    "justificativa": "Questão visual original. Gabarito fonte: C. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2010.1",
    "numeroOriginal": 136,
    "gabaritoOriginal": "C",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 41,
      "alt": "Material visual original da questão 136"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0138",
    "numero": 1638,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "Questão de planificação de uma superfície semicilíndrica.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original E"
    },
    "correta": "D",
    "justificativa": "Questão visual original. Gabarito fonte: E. No simulador de 4 opções, as alternativas originais A, B, C, E são remapeadas para A, B, C e D.",
    "origem": "2010.1",
    "numeroOriginal": 138,
    "gabaritoOriginal": "E",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 42,
      "alt": "Material visual original da questão 138"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "E"
    },
    "visualAlternativaRemovida": "D",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0142",
    "numero": 1642,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.1",
    "enunciado": "Questão que pede o gráfico correspondente ao crescimento da altura de uma criança.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "A",
    "justificativa": "Questão visual original. Gabarito fonte: A. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2010.1",
    "numeroOriginal": 142,
    "gabaritoOriginal": "A",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 43,
      "alt": "Material visual original da questão 142"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0181",
    "numero": 1681,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "Questão sobre a forma de uma lixeira composta por retângulos, trapézios e base quadrada.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "C",
    "justificativa": "Questão visual original. Gabarito fonte: C. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2010.2",
    "numeroOriginal": 181,
    "gabaritoOriginal": "C",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 53,
      "alt": "Material visual original da questão 181"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0182",
    "numero": 1682,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2010.2",
    "enunciado": "Questão de menor caminho para um cabo em um ambiente tridimensional; o desenho é necessário.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original E"
    },
    "correta": "D",
    "justificativa": "Questão visual original. Gabarito fonte: E. No simulador de 4 opções, as alternativas originais A, B, C, E são remapeadas para A, B, C e D.",
    "origem": "2010.2",
    "numeroOriginal": 182,
    "gabaritoOriginal": "E",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 53,
      "alt": "Material visual original da questão 182"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "E"
    },
    "visualAlternativaRemovida": "D",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0242",
    "numero": 1742,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "Questão que pede a identificação do gráfico do preço em função da massa.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original E"
    },
    "correta": "D",
    "justificativa": "Questão visual original. Gabarito fonte: E. No simulador de 4 opções, as alternativas originais A, B, C, E são remapeadas para A, B, C e D.",
    "origem": "2011.1",
    "numeroOriginal": 242,
    "gabaritoOriginal": "E",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 68,
      "alt": "Material visual original da questão 242"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "E"
    },
    "visualAlternativaRemovida": "D",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0269",
    "numero": 1769,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.1",
    "enunciado": "Questão que pede o gráfico de dois planos de telefonia com faixas de cobrança.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "D",
    "justificativa": "Questão visual original. Gabarito fonte: D. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2011.1",
    "numeroOriginal": 269,
    "gabaritoOriginal": "D",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 76,
      "alt": "Material visual original da questão 269"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0288",
    "numero": 1788,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "Questão que pede a representação gráfica da altura do salto em função da temperatura.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "A",
    "justificativa": "Questão visual original. Gabarito fonte: A. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2011.2",
    "numeroOriginal": 288,
    "gabaritoOriginal": "A",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 81,
      "alt": "Material visual original da questão 288"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0303",
    "numero": 1803,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "Questão envolvendo a relação entre escalas Celsius e Fahrenheit em gráfico.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "B",
    "justificativa": "Questão visual original. Gabarito fonte: B. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2011.2",
    "numeroOriginal": 303,
    "gabaritoOriginal": "B",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 85,
      "alt": "Material visual original da questão 303"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0315",
    "numero": 1815,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2011.2",
    "enunciado": "Questão com figura geométrica necessária à resolução.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "B",
    "justificativa": "Questão visual original. Gabarito fonte: B. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2011.2",
    "numeroOriginal": 315,
    "gabaritoOriginal": "B",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 88,
      "alt": "Material visual original da questão 315"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0333",
    "numero": 1833,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "Questão com representação visual de uma situação geométrica.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original E"
    },
    "correta": "D",
    "justificativa": "Questão visual original. Gabarito fonte: E. No simulador de 4 opções, as alternativas originais A, B, C, E são remapeadas para A, B, C e D.",
    "origem": "2012.1",
    "numeroOriginal": 333,
    "gabaritoOriginal": "E",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 93,
      "alt": "Material visual original da questão 333"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "E"
    },
    "visualAlternativaRemovida": "D",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0336",
    "numero": 1836,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "Questão com figura/diagrama indispensável.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original E"
    },
    "correta": "D",
    "justificativa": "Questão visual original. Gabarito fonte: E. No simulador de 4 opções, as alternativas originais A, B, C, E são remapeadas para A, B, C e D.",
    "origem": "2012.1",
    "numeroOriginal": 336,
    "gabaritoOriginal": "E",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 94,
      "alt": "Material visual original da questão 336"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "E"
    },
    "visualAlternativaRemovida": "D",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0345",
    "numero": 1845,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "Questão com alternativas apresentadas por figuras.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "C",
    "justificativa": "Questão visual original. Gabarito fonte: C. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2012.1",
    "numeroOriginal": 345,
    "gabaritoOriginal": "C",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 97,
      "alt": "Material visual original da questão 345"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0349",
    "numero": 1849,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "Questão com representação visual.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original E"
    },
    "correta": "D",
    "justificativa": "Questão visual original. Gabarito fonte: E. No simulador de 4 opções, as alternativas originais A, B, C, E são remapeadas para A, B, C e D.",
    "origem": "2012.1",
    "numeroOriginal": 349,
    "gabaritoOriginal": "E",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 98,
      "alt": "Material visual original da questão 349"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "E"
    },
    "visualAlternativaRemovida": "D",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0350",
    "numero": 1850,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.1",
    "enunciado": "Questão com gráfico entre as alternativas.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "D",
    "justificativa": "Questão visual original. Gabarito fonte: D. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2012.1",
    "numeroOriginal": 350,
    "gabaritoOriginal": "D",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 98,
      "alt": "Material visual original da questão 350"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0386",
    "numero": 1886,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "Questão com figura geométrica.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "B",
    "justificativa": "Questão visual original. Gabarito fonte: B. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2012.2",
    "numeroOriginal": 386,
    "gabaritoOriginal": "B",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 107,
      "alt": "Material visual original da questão 386"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0405",
    "numero": 1905,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2012.2",
    "enunciado": "Questão com gráficos nas alternativas.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "D",
    "justificativa": "Questão visual original. Gabarito fonte: D. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2012.2",
    "numeroOriginal": 405,
    "gabaritoOriginal": "D",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 113,
      "alt": "Material visual original da questão 405"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0421",
    "numero": 1921,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "Questão com desenho geométrico.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original E"
    },
    "correta": "D",
    "justificativa": "Questão visual original. Gabarito fonte: E. No simulador de 4 opções, as alternativas originais A, B, C, E são remapeadas para A, B, C e D.",
    "origem": "2013.1",
    "numeroOriginal": 421,
    "gabaritoOriginal": "E",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 118,
      "alt": "Material visual original da questão 421"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "E"
    },
    "visualAlternativaRemovida": "D",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0424",
    "numero": 1924,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "Questão com figura nas alternativas.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "B",
    "justificativa": "Questão visual original. Gabarito fonte: B. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2013.1",
    "numeroOriginal": 424,
    "gabaritoOriginal": "B",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 119,
      "alt": "Material visual original da questão 424"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0434",
    "numero": 1934,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "Questão com representação visual.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original E"
    },
    "correta": "D",
    "justificativa": "Questão visual original. Gabarito fonte: E. No simulador de 4 opções, as alternativas originais A, B, C, E são remapeadas para A, B, C e D.",
    "origem": "2013.1",
    "numeroOriginal": 434,
    "gabaritoOriginal": "E",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 122,
      "alt": "Material visual original da questão 434"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "E"
    },
    "visualAlternativaRemovida": "D",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0450",
    "numero": 1950,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.1",
    "enunciado": "Questão com representação visual.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "B",
    "justificativa": "Questão visual original. Gabarito fonte: B. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2013.1",
    "numeroOriginal": 450,
    "gabaritoOriginal": "B",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 126,
      "alt": "Material visual original da questão 450"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0463",
    "numero": 1963,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "Questão que depende de gráfico.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "A",
    "justificativa": "Questão visual original. Gabarito fonte: A. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2013.2",
    "numeroOriginal": 463,
    "gabaritoOriginal": "A",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 130,
      "alt": "Material visual original da questão 463"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0477",
    "numero": 1977,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2013.2",
    "enunciado": "Questão com figuras nas alternativas.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "D",
    "justificativa": "Questão visual original. Gabarito fonte: D. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2013.2",
    "numeroOriginal": 477,
    "gabaritoOriginal": "D",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 133,
      "alt": "Material visual original da questão 477"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0503",
    "numero": 2003,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "Questão com representação visual.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "D",
    "justificativa": "Questão visual original. Gabarito fonte: D. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2014.1",
    "numeroOriginal": 503,
    "gabaritoOriginal": "D",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 140,
      "alt": "Material visual original da questão 503"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0504",
    "numero": 2004,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "Questão com gráfico.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original E"
    },
    "correta": "D",
    "justificativa": "Questão visual original. Gabarito fonte: E. No simulador de 4 opções, as alternativas originais A, B, C, E são remapeadas para A, B, C e D.",
    "origem": "2014.1",
    "numeroOriginal": 504,
    "gabaritoOriginal": "E",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 141,
      "alt": "Material visual original da questão 504"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "E"
    },
    "visualAlternativaRemovida": "D",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0520",
    "numero": 2020,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "Questão com figura.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "C",
    "justificativa": "Questão visual original. Gabarito fonte: C. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2014.1",
    "numeroOriginal": 520,
    "gabaritoOriginal": "C",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 145,
      "alt": "Material visual original da questão 520"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0525",
    "numero": 2025,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.1",
    "enunciado": "Questão em que as opções de resposta são placas apresentadas visualmente.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "C",
    "justificativa": "Questão visual original. Gabarito fonte: C. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2014.1",
    "numeroOriginal": 525,
    "gabaritoOriginal": "C",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 147,
      "alt": "Material visual original da questão 525"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0542",
    "numero": 2042,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "Questão sobre a vista superior de uma molécula; alternativas gráficas.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "B",
    "justificativa": "Questão visual original. Gabarito fonte: B. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2014.2",
    "numeroOriginal": 542,
    "gabaritoOriginal": "B",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 152,
      "alt": "Material visual original da questão 542"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0543",
    "numero": 2043,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.2",
    "enunciado": "Questão de planificação de um prisma; alternativas gráficas.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original E"
    },
    "correta": "D",
    "justificativa": "Questão visual original. Gabarito fonte: E. No simulador de 4 opções, as alternativas originais A, B, C, E são remapeadas para A, B, C e D.",
    "origem": "2014.2",
    "numeroOriginal": 543,
    "gabaritoOriginal": "E",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 152,
      "alt": "Material visual original da questão 543"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "E"
    },
    "visualAlternativaRemovida": "D",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0598",
    "numero": 2098,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "Questão de deslocamento em malha quadriculada; alternativas gráficas.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "A",
    "justificativa": "Questão visual original. Gabarito fonte: A. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2014.3",
    "numeroOriginal": 598,
    "gabaritoOriginal": "A",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 166,
      "alt": "Material visual original da questão 598"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0599",
    "numero": 2099,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "Questão de menor caminho sobre a superfície de uma caixa; alternativas gráficas.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original E"
    },
    "correta": "D",
    "justificativa": "Questão visual original. Gabarito fonte: E. No simulador de 4 opções, as alternativas originais A, B, C, E são remapeadas para A, B, C e D.",
    "origem": "2014.3",
    "numeroOriginal": 599,
    "gabaritoOriginal": "E",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 167,
      "alt": "Material visual original da questão 599"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "E"
    },
    "visualAlternativaRemovida": "D",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0616",
    "numero": 2116,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "Questão que pede o gráfico da quantidade de substância no organismo ao longo do tempo.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "A",
    "justificativa": "Questão visual original. Gabarito fonte: A. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2014.3",
    "numeroOriginal": 616,
    "gabaritoOriginal": "A",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 171,
      "alt": "Material visual original da questão 616"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0624",
    "numero": 2124,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2014.3",
    "enunciado": "Questão que pede o gráfico das alturas de água em dois reservatórios em função do volume.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "B",
    "justificativa": "Questão visual original. Gabarito fonte: B. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2014.3",
    "numeroOriginal": 624,
    "gabaritoOriginal": "B",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 173,
      "alt": "Material visual original da questão 624"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0633",
    "numero": 2133,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "Questão que pede o gráfico do valor mensal de um plano de telefonia em função das ligações.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "B",
    "justificativa": "Questão visual original. Gabarito fonte: B. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2015.1",
    "numeroOriginal": 633,
    "gabaritoOriginal": "B",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 176,
      "alt": "Material visual original da questão 633"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0652",
    "numero": 2152,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "Questão com curva y = log(x) e desenho do vidro; a figura é necessária.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original E"
    },
    "correta": "D",
    "justificativa": "Questão visual original. Gabarito fonte: E. No simulador de 4 opções, as alternativas originais A, B, C, E são remapeadas para A, B, C e D.",
    "origem": "2015.1",
    "numeroOriginal": 652,
    "gabaritoOriginal": "E",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 182,
      "alt": "Material visual original da questão 652"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "E"
    },
    "visualAlternativaRemovida": "D",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0665",
    "numero": 2165,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.1",
    "enunciado": "Questão sobre cortes em uma folha dobrada e a forma final de uma bandeirinha.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original E"
    },
    "correta": "D",
    "justificativa": "Questão visual original. Gabarito fonte: E. No simulador de 4 opções, as alternativas originais A, B, C, E são remapeadas para A, B, C e D.",
    "origem": "2015.1",
    "numeroOriginal": 665,
    "gabaritoOriginal": "E",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 186,
      "alt": "Material visual original da questão 665"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "E"
    },
    "visualAlternativaRemovida": "D",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0706",
    "numero": 2206,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2015.2",
    "enunciado": "Questão sobre a planificação de um cubo após imersão em tinta.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "C",
    "justificativa": "Questão visual original. Gabarito fonte: C. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2015.2",
    "numeroOriginal": 706,
    "gabaritoOriginal": "C",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 196,
      "alt": "Material visual original da questão 706"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0757",
    "numero": 2257,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "Questão de projeção ortogonal de um caminho sobre o globo terrestre.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original E"
    },
    "correta": "D",
    "justificativa": "Questão visual original. Gabarito fonte: E. No simulador de 4 opções, as alternativas originais A, B, C, E são remapeadas para A, B, C e D.",
    "origem": "2016.1",
    "numeroOriginal": 757,
    "gabaritoOriginal": "E",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 211,
      "alt": "Material visual original da questão 757"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "E"
    },
    "visualAlternativaRemovida": "D",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0763",
    "numero": 2263,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.1",
    "enunciado": "Questão que pede o esboço lateral de uma cadeira fechada.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "C",
    "justificativa": "Questão visual original. Gabarito fonte: C. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2016.1",
    "numeroOriginal": 763,
    "gabaritoOriginal": "C",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 213,
      "alt": "Material visual original da questão 763"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0779",
    "numero": 2279,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "Questão que pede o gráfico da eficácia de um medicamento ao longo de 12 horas.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "C",
    "justificativa": "Questão visual original. Gabarito fonte: C. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2016.2",
    "numeroOriginal": 779,
    "gabaritoOriginal": "C",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 218,
      "alt": "Material visual original da questão 779"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0790",
    "numero": 2290,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.2",
    "enunciado": "Questão de trajetória mínima sobre uma estrutura de tenda em forma de prisma.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original E"
    },
    "correta": "D",
    "justificativa": "Questão visual original. Gabarito fonte: E. No simulador de 4 opções, as alternativas originais A, B, C, E são remapeadas para A, B, C e D.",
    "origem": "2016.2",
    "numeroOriginal": 790,
    "gabaritoOriginal": "E",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 221,
      "alt": "Material visual original da questão 790"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "E"
    },
    "visualAlternativaRemovida": "D",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0824",
    "numero": 2324,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "Questão sobre relação entre os raios de um canteiro circular e sua faixa.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "B",
    "justificativa": "Questão visual original. Gabarito fonte: B. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2016.3",
    "numeroOriginal": 824,
    "gabaritoOriginal": "B",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 230,
      "alt": "Material visual original da questão 824"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0827",
    "numero": 2327,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "Questão sobre a colagem de uma faixa retangular na superfície lateral de um cilindro.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "A",
    "justificativa": "Questão visual original. Gabarito fonte: A. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2016.3",
    "numeroOriginal": 827,
    "gabaritoOriginal": "A",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 231,
      "alt": "Material visual original da questão 827"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0847",
    "numero": 2347,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "Questão de área da cobertura de uma tenda piramidal.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "A",
    "justificativa": "Questão visual original. Gabarito fonte: A. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2016.3",
    "numeroOriginal": 847,
    "gabaritoOriginal": "A",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 236,
      "alt": "Material visual original da questão 847"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0850",
    "numero": 2350,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2016.3",
    "enunciado": "Questão que pede um gráfico possível para a concentração de álcool no sangue.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original E"
    },
    "correta": "D",
    "justificativa": "Questão visual original. Gabarito fonte: E. No simulador de 4 opções, as alternativas originais A, B, C, E são remapeadas para A, B, C e D.",
    "origem": "2016.3",
    "numeroOriginal": 850,
    "gabaritoOriginal": "E",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 238,
      "alt": "Material visual original da questão 850"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "E"
    },
    "visualAlternativaRemovida": "D",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0881",
    "numero": 2381,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "Questão que pede o gráfico do nível de água em dois reservatórios interligados.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "D",
    "justificativa": "Questão visual original. Gabarito fonte: D. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2017.1",
    "numeroOriginal": 881,
    "gabaritoOriginal": "D",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 250,
      "alt": "Material visual original da questão 881"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0884",
    "numero": 2384,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.1",
    "enunciado": "Questão financeira cuja expressão aparece visualmente no material-fonte.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "A",
    "justificativa": "Questão visual original. Gabarito fonte: A. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2017.1",
    "numeroOriginal": 884,
    "gabaritoOriginal": "A",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 252,
      "alt": "Material visual original da questão 884"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0923",
    "numero": 2423,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "Questão que pede o gráfico das vendas em função do tempo.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "D",
    "justificativa": "Questão visual original. Gabarito fonte: D. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2017.2",
    "numeroOriginal": 923,
    "gabaritoOriginal": "D",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 268,
      "alt": "Material visual original da questão 923"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0939",
    "numero": 2439,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "Questão de projeção ortogonal dos deslocamentos de uma lagartixa em um quarto.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "B",
    "justificativa": "Questão visual original. Gabarito fonte: B. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2017.2",
    "numeroOriginal": 939,
    "gabaritoOriginal": "B",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 273,
      "alt": "Material visual original da questão 939"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0941",
    "numero": 2441,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "Questão que pede a projeção vertical de uma trajetória em um prédio.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "B",
    "justificativa": "Questão visual original. Gabarito fonte: B. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2017.2",
    "numeroOriginal": 941,
    "gabaritoOriginal": "B",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 274,
      "alt": "Material visual original da questão 941"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0949",
    "numero": 2449,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "Questão sobre uma malha de circunferências e semirretas em coordenadas polares.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "A",
    "justificativa": "Questão visual original. Gabarito fonte: A. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2018.1",
    "numeroOriginal": 949,
    "gabaritoOriginal": "A",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 277,
      "alt": "Material visual original da questão 949"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0958",
    "numero": 2458,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "Questão sobre campanha publicitária; a representação gráfica/formatação do item precisa ser preservada.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "A",
    "justificativa": "Questão visual original. Gabarito fonte: A. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2018.1",
    "numeroOriginal": 958,
    "gabaritoOriginal": "A",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 280,
      "alt": "Material visual original da questão 958"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0973",
    "numero": 2473,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "Questão de Minecraft envolvendo um cubo 4 x 4 x 4 e uma peça formada pelos cubinhos restantes.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "A",
    "justificativa": "Questão visual original. Gabarito fonte: A. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2018.1",
    "numeroOriginal": 973,
    "gabaritoOriginal": "A",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 285,
      "alt": "Material visual original da questão 973"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0985",
    "numero": 2485,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "Questão que pede o gráfico da distância do ponto médio de uma viga ao ponto O durante o içamento.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "A",
    "justificativa": "Questão visual original. Gabarito fonte: A. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2018.1",
    "numeroOriginal": 985,
    "gabaritoOriginal": "A",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 289,
      "alt": "Material visual original da questão 985"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-0991",
    "numero": 2491,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "Questão sobre a trajetória do ponto preto em uma torneira de 1/4 de volta.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "A",
    "justificativa": "Questão visual original. Gabarito fonte: A. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2018.2",
    "numeroOriginal": 991,
    "gabaritoOriginal": "A",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 291,
      "alt": "Material visual original da questão 991"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-1004",
    "numero": 2504,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "Questão que depende do quadro de classificação de pH.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "C",
    "justificativa": "Questão visual original. Gabarito fonte: C. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2018.2",
    "numeroOriginal": 1004,
    "gabaritoOriginal": "C",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 296,
      "alt": "Material visual original da questão 1004"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-1019",
    "numero": 2519,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "Questão sobre cinco transformações isométricas aplicadas a uma figura.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "C",
    "justificativa": "Questão visual original. Gabarito fonte: C. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2018.2",
    "numeroOriginal": 1019,
    "gabaritoOriginal": "C",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 300,
      "alt": "Material visual original da questão 1019"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-1025",
    "numero": 2525,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "Questão que depende do segmento de reta apresentado no gráfico do teste de combustível.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "B",
    "justificativa": "Questão visual original. Gabarito fonte: B. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2018.2",
    "numeroOriginal": 1025,
    "gabaritoOriginal": "B",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 302,
      "alt": "Material visual original da questão 1025"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-1029",
    "numero": 2529,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "Questão que depende do quadro de preços e rendimentos dos combustíveis A e B.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "A",
    "justificativa": "Questão visual original. Gabarito fonte: A. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2018.2",
    "numeroOriginal": 1029,
    "gabaritoOriginal": "A",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 303,
      "alt": "Material visual original da questão 1029"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-1033",
    "numero": 2533,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "Questão de rotação de uma figura plana para gerar uma anticlepsidra.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "B",
    "justificativa": "Questão visual original. Gabarito fonte: B. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2018.2",
    "numeroOriginal": 1033,
    "gabaritoOriginal": "B",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 304,
      "alt": "Material visual original da questão 1033"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-1034",
    "numero": 2534,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "Questão que pede o gráfico da resistência em função da área da seção transversal.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original D"
    },
    "correta": "C",
    "justificativa": "Questão visual original. Gabarito fonte: C. No simulador de 4 opções, as alternativas originais A, B, C, D são remapeadas para A, B, C e D.",
    "origem": "2018.2",
    "numeroOriginal": 1034,
    "gabaritoOriginal": "C",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 305,
      "alt": "Material visual original da questão 1034"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "D"
    },
    "visualAlternativaRemovida": "E",
    "status": "pendente_visual"
  },
  {
    "id": "mat-enem-visual-1035",
    "numero": 2535,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.2",
    "enunciado": "Questão sobre figuras de duração musical; a apresentação gráfica da sequência faz parte do item.",
    "alternativas": {
      "A": "Alternativa visual original A",
      "B": "Alternativa visual original B",
      "C": "Alternativa visual original C",
      "D": "Alternativa visual original E"
    },
    "correta": "D",
    "justificativa": "Questão visual original. Gabarito fonte: E. No simulador de 4 opções, as alternativas originais A, B, C, E são remapeadas para A, B, C e D.",
    "origem": "2018.2",
    "numeroOriginal": 1035,
    "gabaritoOriginal": "E",
    "visual": {
      "sourceUrl": "https://www.professoresdematematica.com.br/wa_files/questoes%20enem%202009%20a%202018.pdf",
      "sourcePage": 305,
      "alt": "Material visual original da questão 1035"
    },
    "visualAlternativas": {
      "A": "A",
      "B": "B",
      "C": "C",
      "D": "E"
    },
    "visualAlternativaRemovida": "D",
    "status": "pendente_visual"
  }
] as VisualMathActiveQuestion[];
